import { getInstance } from './index'

function getQueryVariable (variable) {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (decodeURIComponent(pair[0]) === variable) {
      return decodeURIComponent(pair[1])
    }
  }
  console.log('Query variable %s not found', variable)
}

export const authGuard = (to, from, next) => {
  const authService = getInstance()

  const fn = () => {
    // If the user is authenticated, continue with the route
    if (authService.isAuthenticated) {
      return next()
    }
    var showVariable = getQueryVariable('show')
    console.log('!!!!!!!!Showvariable' + showVariable)
    if (!this.isAuthenticated && showVariable) {
      console.log('*************************Sending passwordless')
      authService.loginWithPasswordlessRedirect({ appState: { targetUrl: to.fullPath }, fragment: 'passwordless' })
    //  this.loginWithPasswordlessRedirect()
    } else {
    // Otherwise, log in
      authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } })
    }
  }

  // If loading has already finished, check our auth state using `fn()`
  if (!authService.loading) {
    return fn()
  }

  // Watch for the loading property to change before we check isAuthenticated
  authService.$watch('loading', loading => {
    if (loading === false) {
      return fn()
    }
  })
}



// WEBPACK FOOTER //
// ./src/auth/authGuard.js